import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
}

const initialAuthState: IAuthState = {
  userId: undefined,
  userName: undefined,
  fullName: undefined,
  accessToken: undefined,
  refreshToken: undefined,
  companyName: undefined,
  companyId: undefined,
  companyCode: undefined,
  divisionName: undefined,
  divisionCode: undefined,
  divisionId: undefined,
  phone: undefined,
  sessionId: undefined,
}

export interface IAuthState {
  userId?: string
  userName?: string
  fullName?: string
  accessToken?: string
  refreshToken?: string
  companyName?: string
  companyId?: string
  companyCode?: string
  divisionName?: string
  divisionCode?: string
  divisionId?: string
  phone?: string
  sessionId?: string
}

export const reducer = persistReducer(
  {storage, key: 'root', blacklist: ['accessToken', 'refreshToken']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const accessToken = action.payload?.accessToken
        const refreshToken = action.payload?.refreshToken
        const userName = action.payload?.userName
        const fullName = action.payload?.fullName
        const companyName = action.payload?.companyName
        const companyId = action.payload?.companyId
        const companyCode = action.payload?.companyCode
        const divisionName = action.payload?.divisionName
        const divisionCode = action.payload?.divisionCode
        const divisionId = action.payload?.divisionId
        const userId = action.payload?.userId
        const phone = action.payload?.phone
        const sessionId = action.payload?.sessionId
        return {
          accessToken,
          refreshToken,
          userId,
          userName,
          fullName,
          companyName,
          divisionName,
          divisionCode,
          divisionId,
          companyCode,
          companyId,
          phone,
          sessionId,
        }
      }
      case actionTypes.Logout: {
        return initialAuthState
      }
      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: any) => ({type: actionTypes.Login, payload: accessToken}),
  logout: () => ({type: actionTypes.Logout}),
}

export function* saga() {
  // yield takeLatest(actionTypes.Login, function* loginSaga() {
  //   yield put(actions.requestUser())
  // })
  // yield takeLatest(actionTypes.Register, function* registerSaga() {
  //   yield put(actions.requestUser())
  // })
  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //   const {data: user} = yield getUserByToken()
  //   yield put(actions.fulfillUser(user))
  // })
}
